<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 387 553.48">
        <g id="Layer_2">
            <g id="Layer_1-2">
                <path
                    class="cls-1"
                    d="M255,52,205.91,6.1H57.67L15.46,45.6H82.4L57.67,68.74v283l-42.21,39.5H205.91L255,345.3V201.77h-25.9L255,182.36ZM207.48,175.09V328.51l-24.24,23.2H80.35l24.81-23.2V201.77H89.24l15.92-14.9V45.6h78.08l24.24,23.14v93.53h13.68Z"
                />
                <path
                    class="cls-2"
                    d="M205.69,168.38l-4.32,4V325.88L180.79,345.6h-85l15.46-14.47V195.66H104.7l6.57-6.16V51.71h69.52l20.58,19.66v97Zm1.79,6.71V328.51l-24.24,23.2H80.35l24.81-23.2V201.77H89.24l15.92-14.9V45.6h78.08l24.24,23.14v93.53h13.68ZM255,52,205.91,6.1H57.67L15.46,45.6H82.4L57.67,68.74v283l-42.21,39.5H205.91L255,345.3V201.77h-25.9L255,182.36Zm6.1,133.4V49.33L208.33,0H55.27L0,51.71H66.94L51.57,66.06v283L0,397.31H208.33L261.07,348V195.66H247.42Z"
                />
                <path
                    class="cls-1"
                    d="M281.84,162.27,255,182.36l-25.9,19.41h77.59l-24.82,23.14V455.06l-56,52.81h-21.6l-24.82-23.2V399H131.94V501.52L181,547.37h67.62l80.72-75.52V201.77l42.21-39.5Zm-149.9,62.64V344h47.49V201.22l28-26.13,13.68-12.82H131.45l-42.21,39.5h67.52Z"
                />
                <path
                    class="cls-2"
                    d="M131.94,224.91V344h47.49V201.22l28-26.13,13.68-12.82H131.45l-42.21,39.5h67.52Zm-4.16-4.46-1.94,1.77v127.9l59.7-2.26v-144l26.1-24.29,25-23.38H129l-55.26,51.7h67.48Zm154.06-58.18-52.77,39.5h77.59l-24.82,23.14V455.06l-56,52.81h-21.6l-24.82-23.2V399H131.94V501.52L181,547.37h67.62l80.72-75.52V201.77l42.21-39.5ZM387,156.17H279.81l-69.08,51.7h80.42l-15.42,14.35V452.44l-52.31,49.33H206.66l-21.12-19.72v-89.2h-59.7v111.3l52.74,49.33H251l84.41-78.94V204.39Z"
                />
            </g>
        </g>
    </svg>
</template>

<style scoped>
.cls-1 {
    fill: #1e22aa;
}
.cls-2 {
    fill: #f1f0e2;
    fill-rule: evenodd;
}
</style>
